export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Se connecter",
    "login.form.hint.user": "Identifiant",
    "login.form.hint.password": "Mot de passe",
    "login.form.checkbox.remember-me": "Mémoriser mes informations",
    "login.form.button.sign-in": "Se connecter",
    "login.form.message.invalid-user-credentials": "Le mot de passe ou l'identifiant est incorrect",
    "login.form.message.user-required": "Saisir un identifiant",
    "login.form.message.password-required": "Saisir un mot de passe",
    "login.form.button.forgot-password": "Mot de passe oublié ?",
    "error.root-admin-login.title": "Erreur 403 : action interdite",
    "error.root-admin-login.message": "Vous êtes connecté en tant qu'administrateur en lecture seule. Por accéder à la console Web Recovery veuillez vous identifier en tant qu'utilisateur du locataire client ou administrateur."
};
